// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
import { validatePhoneNumber } from "./phone";
import FeaturesService from "../services/featuresService";
import dateFormatService from "../services/dateFormatService";
import moment from "moment-timezone";
import DOMPurify from "dompurify";

if (!Object.keys) {
  Object.keys = (function () {
    "use strict";
    var hasOwnProperty = Object.prototype.hasOwnProperty,
      hasDontEnumBug = !{ toString: null }.propertyIsEnumerable("toString"),
      dontEnums = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor",
      ],
      dontEnumsLength = dontEnums.length;

    return function (obj) {
      if (
        typeof obj !== "object" &&
        (typeof obj !== "function" || obj === null)
      ) {
        throw new TypeError("Object.keys called on non-object");
      }

      var result = [],
        prop,
        i;

      for (prop in obj) {
        if (hasOwnProperty.call(obj, prop)) {
          result.push(prop);
        }
      }

      if (hasDontEnumBug) {
        for (i = 0; i < dontEnumsLength; i++) {
          if (hasOwnProperty.call(obj, dontEnums[i])) {
            result.push(dontEnums[i]);
          }
        }
      }
      return result;
    };
  })();
}

if (!Object.keysMap) {
  Object.keysMap = (function () {
    "use strict";
    return function (obj, valueKey = "name") {
      if (
        typeof obj !== "object" &&
        (typeof obj !== "function" || obj === null)
      ) {
        throw new TypeError("Object.keys called on non-object");
      }

      // More efficient implementation using Object.entries
      return Object.entries(obj)
        .filter(([_, value]) => value && value.id !== undefined)
        .map(([_, value]) => ({
          id: value.id,
          value: value[valueKey],
        }));
    };
  })();
}

/**

*

*  Base64 encode / decode

*  http://www.webtoolkit.info/

*

**/

export const Base64 = {
  // private property

  _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",

  // public method for encoding

  encode: function (input) {
    var output = "";

    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;

    var i = 0;

    input = Base64._utf8_encode(input);

    while (i < input.length) {
      chr1 = input.charCodeAt(i++);

      chr2 = input.charCodeAt(i++);

      chr3 = input.charCodeAt(i++);

      enc1 = chr1 >> 2;

      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);

      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);

      enc4 = chr3 & 63;

      if (isNaN(chr2)) {
        enc3 = enc4 = 64;
      } else if (isNaN(chr3)) {
        enc4 = 64;
      }

      output =
        output +
        this._keyStr.charAt(enc1) +
        this._keyStr.charAt(enc2) +
        this._keyStr.charAt(enc3) +
        this._keyStr.charAt(enc4);
    }

    return output;
  },

  // public method for decoding

  decode: function (input) {
    var output = "";

    var chr1, chr2, chr3;

    var enc1, enc2, enc3, enc4;

    var i = 0;

    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

    while (i < input.length) {
      enc1 = this._keyStr.indexOf(input.charAt(i++));

      enc2 = this._keyStr.indexOf(input.charAt(i++));

      enc3 = this._keyStr.indexOf(input.charAt(i++));

      enc4 = this._keyStr.indexOf(input.charAt(i++));

      chr1 = (enc1 << 2) | (enc2 >> 4);

      chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);

      chr3 = ((enc3 & 3) << 6) | enc4;

      output = output + String.fromCharCode(chr1);

      if (enc3 !== 64) {
        output = output + String.fromCharCode(chr2);
      }

      if (enc4 !== 64) {
        output = output + String.fromCharCode(chr3);
      }
    }

    output = Base64._utf8_decode(output);

    return output;
  },

  // private method for UTF-8 encoding

  _utf8_encode: function (string) {
    string = string.replace(/\r\n/g, "\n");

    var utftext = "";

    for (var n = 0; n < string.length; n++) {
      var c = string.charCodeAt(n);

      if (c < 128) {
        utftext += String.fromCharCode(c);
      } else if (c > 127 && c < 2048) {
        utftext += String.fromCharCode((c >> 6) | 192);

        utftext += String.fromCharCode((c & 63) | 128);
      } else {
        utftext += String.fromCharCode((c >> 12) | 224);

        utftext += String.fromCharCode(((c >> 6) & 63) | 128);

        utftext += String.fromCharCode((c & 63) | 128);
      }
    }

    return utftext;
  },

  // private method for UTF-8 decoding

  _utf8_decode: function (utftext) {
    var string = "";

    var i = 0;

    var c = 0;
    var c1 = 0;
    var c2 = 0;
    var c3;

    while (i < utftext.length) {
      c = utftext.charCodeAt(i);

      if (c < 128) {
        string += String.fromCharCode(c);

        i++;
      } else if (c > 191 && c < 224) {
        c2 = utftext.charCodeAt(i + 1);

        string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));

        i += 2;
      } else {
        c2 = utftext.charCodeAt(i + 1);

        c3 = utftext.charCodeAt(i + 2);

        string += String.fromCharCode(
          ((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63)
        );

        i += 3;
      }
    }

    return string;
  },
};

export function findWithAttr(array, attr, value) {
  if (!array) {
    return -1;
  }
  for (let i = 0; i < array.length; i += 1) {
    if (array[i][attr] === value) {
      return i;
    }
  }
  return -1;
}

export const validateEmail = (email) => {
  var re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

export const validateText = (text, minLength = 3, maxLength = 10000) => {
  return text.length >= minLength && text.length <= maxLength;
};

/**
 * Sanitizes plain text input by removing HTML tags and dangerous characters
 * Use this for user input fields like names, addresses, etc. where HTML is NOT expected
 * @param {string} text - The text to sanitize
 * @param {object} options - Optional configuration
 * @param {boolean} options.allowBasicFormatting - Allow apostrophes, hyphens, periods (default: true)
 * @param {boolean} options.preserveNewlines - Preserve line breaks (default: false)
 * @param {boolean} options.trim - Trim leading/trailing spaces (default: true, set false for real-time input)
 * @returns {string} Sanitized text safe for storage and display
 */
export function sanitizePlainText(text, options = {}) {
  if (!text || typeof text !== 'string') {
    return '';
  }

  const { allowBasicFormatting = true, preserveNewlines = false, trim = true } = options;

  // Remove all HTML tags
  let sanitized = text.replace(/<[^>]*>/g, '');

  // Decode common HTML entities that might slip through
  sanitized = sanitized
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, '&')
    .replace(/&quot;/g, '"')
    .replace(/&#x27;/g, "'")
    .replace(/&#x2F;/g, '/')
    .replace(/&nbsp;/g, ' ');

  // Remove any remaining HTML tags after entity decoding
  sanitized = sanitized.replace(/<[^>]*>/g, '');

  // Remove null bytes and other control characters
  sanitized = sanitized.replace(/\x00/g, '');

  if (!preserveNewlines) {
    // Replace newlines with spaces
    sanitized = sanitized.replace(/[\r\n]+/g, ' ');
  }

  if (!allowBasicFormatting) {
    // Remove all special characters except spaces
    sanitized = sanitized.replace(/[^\w\s]/g, '');
  } else {
    // Allow common name/address characters: letters, numbers, spaces, apostrophes, hyphens, periods, commas
    // Also preserve unicode characters for international names
    sanitized = sanitized.replace(/[<>{}[\]\\]/g, '');
  }

  // Collapse multiple spaces into one
  sanitized = sanitized.replace(/\s+/g, ' ');

  // Trim only if requested (skip for real-time input to allow typing spaces)
  if (trim) {
    sanitized = sanitized.trim();
  }

  return sanitized;
}

/**
 * Validates AND sanitizes text input for plain text fields
 * @param {string} text - The text to validate and sanitize
 * @param {number} minLength - Minimum length (default: 3)
 * @param {number} maxLength - Maximum length (default: 10000)
 * @param {object} options - Sanitization options (passed to sanitizePlainText)
 * @returns {object} { valid: boolean, sanitized: string, error: string }
 */
export function validateAndSanitizePlainText(text, minLength = 3, maxLength = 10000, options = {}) {
  if (!text) {
    return { valid: false, sanitized: '', error: 'Text is required' };
  }

  // Sanitize first
  const sanitized = sanitizePlainText(text, options);

  // Then validate length on sanitized text
  const valid = sanitized.length >= minLength && sanitized.length <= maxLength;

  if (!valid) {
    return {
      valid: false,
      sanitized,
      error: sanitized.length < minLength
        ? `Text must be at least ${minLength} characters`
        : `Text must not exceed ${maxLength} characters`
    };
  }

  // Check if sanitization changed the text (potential XSS attempt)
  if (sanitized !== text.trim()) {
    return {
      valid: false,
      sanitized,
      error: 'Invalid characters detected. Please use only letters, numbers, and basic punctuation.'
    };
  }

  return { valid: true, sanitized, error: null };
}

export function validateUserName(userName) {
  if (!userName) {
    return false;
  }

  // let regex = /^[A-Za-z0-9_]+$/; //letters, numbers and underline
  let regex =
    /^(?:[a-zA-Z0-9_.\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDCF\uFDF0-\uFDFF\uFE70-\uFEFF]|(?:\uD802[\uDE60-\uDE9F]|\uD83B[\uDE00-\uDEFF][\s*])){5,128}$/;
  let valid = regex.test(userName);
  if (!valid) {
    return validateEmail(userName) || validatePhoneNumber(userName);
  } else {
    let dots = 0;
    for (let i = 0; i < userName.length; i++) {
      if (userName[i] === ".") {
        dots++;
      }
    }
    if (dots > 1) {
      return false;
    }
  }

  return true;
}

export function validatePassword(password) {
  if (!password) {
    return false;
  }
  // let regex = /^(?=.*[a-z])(?=.*[0-9])(?=.*[A-Z])(?=\S+$).{6,}$/; //letters, numbers and underline
  let regex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,128}$/; //letters, numbers and underline
  let valid = regex.test(password);
  return valid;
}

export const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

export function romanize(num) {
  if (!+num) return NaN;
  var digits = String(+num).split(""),
    key = [
      "",
      "C",
      "CC",
      "CCC",
      "CD",
      "D",
      "DC",
      "DCC",
      "DCCC",
      "CM",
      "",
      "X",
      "XX",
      "XXX",
      "XL",
      "L",
      "LX",
      "LXX",
      "LXXX",
      "XC",
      "",
      "I",
      "II",
      "III",
      "IV",
      "V",
      "VI",
      "VII",
      "VIII",
      "IX",
    ],
    roman = "",
    i = 3;
  while (i--) roman = (key[+digits.pop() + i * 10] || "") + roman;
  return Array(+digits.join("") + 1).join("M") + roman;
}

// Helper function to create a map of node IDs for faster lookup
function createNodeMap(array) {
  const nodeMap = new Map();

  function mapNode(node) {
    if (node && node.data && node.data.id) {
      nodeMap.set(node.data.id, node);
    }

    if (node && node.children) {
      node.children.forEach(mapNode);
    }
  }

  array.forEach(mapNode);
  return nodeMap;
}

// More efficient version that avoids nested recursion
function processArrayNode(node, id, data) {
  let result = { ...node };

  if (node.data.id === id) {
    result.data = { ...node.data, ...data };
    if (data.title) result.title = data.title;
  } else if (node.children) {
    result.children = node.children.map((child) =>
      processArrayNode(child, id, data)
    );
  }
  return result;
}

export function updateArray(array, id, data) {
  // Create a shallow copy of the array
  return array.map((node) => processArrayNode(node, id, data));
}

function removeArrayNode(node, id) {
  // Base case: if this is the node to remove
  if (node.data.id === id) {
    return true; // Signal to remove
  }

  // If there are children, filter them
  if (node.children && node.children.length) {
    const newChildren = node.children
      .map((child) => removeArrayNode(child, id))
      .filter((result) => result !== true);

    // If any children were filtered out, create a new node
    if (newChildren.length !== node.children.length) {
      return { ...node, children: newChildren };
    }
  }

  // No changes to this branch
  return node;
}

export function removeNode(array, id) {
  // Filter out matching nodes at the top level and process all others
  return array
    .map((node) => removeArrayNode(node, id))
    .filter((result) => result !== true);
}

function addArrayNode(node, id, data) {
  const result = { ...node };

  if (node.data.id === id) {
    // Found target node
    return true;
  } else if (node.children) {
    const newChildren = [];
    let foundTarget = false;

    // Process children with a single loop
    for (const child of node.children) {
      const addResult = addArrayNode(child, id, data);

      if (addResult === true) {
        foundTarget = true;

        // Handle section case
        if (child.data.type === "SECTION") {
          const newChild = { ...child };
          if (!newChild.children) newChild.children = [];
          newChild.children = [...newChild.children, { ...data }];
          newChildren.push(newChild);
        } else {
          // Add original node and then new data
          newChildren.push({ ...child });
          newChildren.push({ ...data });
        }
      } else {
        newChildren.push(addResult);
      }
    }

    if (foundTarget) {
      result.children = newChildren;
    } else {
      result.children = node.children.map((child) =>
        addArrayNode(child, id, data)
      );
    }
  }

  return result;
}

export function addNode(array, id, data, oneLevelSection = false) {
  console.log("ADD NODE \nid", id, "\ndata", data, "\ndata id", data.data.id);
  let result = [];

  if (id === false) {
    return array.slice(0).concat([{ ...data }]);
  }

  for (let i = 0; i < array.length; i++) {
    let addResult = addArrayNode(array[i], id, data);
    // console.log('ADD RESULT', i, addResult);

    if (
      addResult === true &&
      array[i].data.type === "SECTION" &&
      data.data.type !== "SECTION"
    ) {
      console.log("INSERT 1");
      let el = { ...array[i] };
      if (!el.children) el.children = [];
      console.log("add element ", el.children.slice(0));
      el.children = el.children.slice(0);
      el.children.push({ ...data });
      result.push({ ...el });
    } else if (addResult === true) {
      console.log("INSERT 2");
      result.push({ ...array[i] });
      result.push({ ...data });
    } else {
      console.log("INSERT 3");
      result.push({ ...addResult });
    }
  }

  // console.log('adding RESULT', result);

  return result;
}

export function guid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function parseURLQueryParams(search) {
  //search: "?cp=email"
  if (!search || !search.substring(1)) {
    return {};
  }
  search = search.substring(1);
  let params = search.split("&");
  if (params && params.length > 0) {
    let out = {};
    params.forEach((p) => {
      let values = p.split("=");
      out[values[0]] = values[1];
    });
    return out;
  }
  return {};
}

export function isAbsoluteURL(url) {
  return !!(
    url &&
    (url.indexOf("http://") === 0 || url.indexOf("https://") === 0)
  );
}

export const months = {
  1: "Jan",
  2: "Feb",
  3: "Mar",
  4: "Apr",
  5: "May",
  6: "Jun",
  7: "Jul",
  8: "Aug",
  9: "Sep",
  10: "Oct",
  11: "Nov",
  12: "Dec",
};

export function formatSlotDate(start, end) {
  return moment(start).format("LLLL") + " - " + moment(end).format("LT");
}

export function getAppointmentArrivalTime(arriveBeforeMins, start) {
  // Handle both Date objects and timestamp numbers
  let startTime;
  if (start instanceof Date) {
    startTime = start.getTime();
  } else if (typeof start === "number") {
    startTime = start;
  } else {
    // Fallback: try to convert to Date
    startTime = new Date(start).getTime();
  }

  let d = new Date(startTime - arriveBeforeMins * 60 * 1000);
  return moment(d).format("LLLL");
}

export function getLangFromLocale(locale) {
  if (!locale) {
    return;
  }
  let parts = locale.split("_");
  return parts[0];
}
export function getCountryFromLocale(locale) {
  if (!locale) {
    return;
  }
  let parts = locale.split("_");
  return parts[1];
}

export function secondsToHms(d) {
  d = Number(d);

  var h = Math.floor(d / 60);
  var m = Math.floor(d % 60);
  // var s = Math.floor((d % 60) % 60);

  let str = "";
  if (h > 0) {
    str += `${h} hr`;
  }
  if (m > 0) {
    str += ` ${m} min`;
  }
  // str += ` ${s} sec`;
  return str;
}

export function secondsToHourMinSecs(d) {
  d = Number(d);

  let h = Math.floor(d / 3600);
  let remainder = Math.floor(d % 3600);
  let m = Math.floor(remainder / 60);
  let s = Math.floor(remainder % 60);

  let str = "";
  if (h > 0) {
    str += `${h} hr`;
  }
  if (m > 0) {
    str += ` ${m} min`;
  }
  str += ` ${s} sec`;
  return str;
}

export function isIE() {
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf("MSIE ");
  return msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./);
}

export function getDomain() {
  let url = window.location.href;
  let parts = url.split("/");
  return parts[2] || "";
}

export function scrollMainLayoutY(y) {
  doScrollY("main-layout", y);
}

export function doScrollY(elId, y) {
  let element = document.getElementById(elId);
  if (element.scrollTo) {
    element.scrollTo(0, y);
  } else {
    element.scrollTop = y;
  }
}

export function getScreeningSurveyId(screening) {
  let { screeningSurveyLink, screeningResponseLink } = screening;

  if (screeningSurveyLink) {
    let parts = screeningSurveyLink.split("/");
    if (parts.length === 4) {
      return parts[3];
    }
  }
  if (screeningResponseLink) {
    let parts = screeningResponseLink.split("/");
    if (parts.length === 4) {
      return parts[3];
    }
  }
  return null;
}

export function strReplaceLast(text, which, what) {
  let n = text.lastIndexOf(which);
  if (n === -1) {
    return text;
  }

  return text.slice(0, n) + text.slice(n).replace(which, what);
}

// Sanitise CSS content inside <style> blocks to prevent CSS-based exfiltration
// while preserving legitimate formatting including background images
const SAFE_URL_PATTERN = /^['"]?(?:\/|https?:\/\/(?:[^/]*\.)?mypatientspace\.com\b|data:image\/)/i;

function sanitizeCSS(css) {
  return css
    .replace(/url\s*\(([^)]*)\)/gi, (match, inner) => {
      // Allow same-origin paths (/img/...), mypatientspace.com URLs, and data:image URIs
      if (SAFE_URL_PATTERN.test(inner.trim())) return match;
      return "/* blocked */";
    })
    .replace(/@import\b[^;]*/gi, "/* blocked */")
    .replace(/expression\s*\([^)]*\)/gi, "/* blocked */")
    .replace(/behavior\s*:\s*[^;]*/gi, "/* blocked */")
    .replace(/-moz-binding\s*:\s*[^;]*/gi, "/* blocked */");
}

export function sanitizeHTML(html) {
  // Extract style tags before sanitization, sanitise CSS content, then replace with placeholders
  const styleTags = [];
  let htmlWithPlaceholders = html.replace(/<style[^>]*>([\s\S]*?)<\/style>/gi, (match, content) => {
    const index = styleTags.length;
    const sanitisedStyle = `<style>${sanitizeCSS(content)}</style>`;
    styleTags.push(sanitisedStyle);
    return `<span data-style-placeholder="${index}" style="display:none;"></span>`;
  });

  const config = {
    ALLOWED_TAGS: [
      "iframe",
      "embed",
      "video",
      "audio",
      "img",
      "a",
      "p",
      "br",
      "strong",
      "em",
      "ul",
      "ol",
      "li",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "div",
      "section",
      "span",
      "b",
      "i",
      "u",
      "blockquote",
      "code",
      "pre",
      "style",
      "table",
      "thead",
      "tbody",
      "tfoot",
      "tr",
      "th",
      "td",
      "caption",
      "colgroup",
      "col",
    ],
    ALLOWED_ATTR: [
      "src",
      "alt",
      "width",
      "height",
      "frameborder",
      "allowfullscreen",
      "autoplay",
      "fullscreen",
      "poster",
      "href",
      "title",
      "controls",
      "target",
      "rel",
      "class",
      "dir",
      "allow", // For iframe permissions
      "sandbox", // For iframe security
      "name", // Common embed attribute
      "id", // Common embed attribute
      "scrolling", // For iframe scrolling
      "loading", // For lazy loading
      "type", // For embed types
      "style", // Inline styles
      "referrerpolicy", // For iframe security
      "data-style-placeholder", // For our style preservation
      "colspan",
      "rowspan",
      "span",
      "align",
      "valign",
      "scope",
      "headers",
      "border",
      "cellpadding",
      "cellspacing",
      "bgcolor",
    ],
    ALLOWED_URI_REGEXP:
      /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp|spotify:|youtube:|vimeo:|linkedin:|):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i,
    ADD_ATTR: ["style", "data-style-placeholder", "referrerpolicy"],
    ALLOW_DATA_ATTR: true,
    FORBID_TAGS: [],
    FORBID_CONTENTS: [],
    WHOLE_DOCUMENT: false,
  };

  // Sanitize the HTML with placeholders
  let result = DOMPurify.sanitize(htmlWithPlaceholders, config);

  // Restore style tags from placeholders (span elements with data attributes)
  // Make the regex more flexible to catch attribute order variations
  result = result.replace(/<span[^>]*data-style-placeholder="(\d+)"[^>]*><\/span>/g, (match, index) => {
    return styleTags[parseInt(index)] || '';
  });

  // Also try with single quotes or no quotes (in case DOMPurify changes it)
  result = result.replace(/<span[^>]*data-style-placeholder='(\d+)'[^>]*><\/span>/g, (match, index) => {
    return styleTags[parseInt(index)] || '';
  });

  // Clean up any leftover placeholder spans that didn't match
  result = result.replace(/<span[^>]*data-style-placeholder[^>]*><\/span>/g, '');

  // Preserve blank lines: Tiptap serializes empty paragraphs as <p></p>, which
  // collapse to zero height when rendered via dangerouslySetInnerHTML.
  result = result.replace(/<p([^>]*)>(\s|&nbsp;)*<\/p>/gi, '<p$1><br></p>');

  return result;
}
export function stripHTML(html) {
  if (!html) {
    return "";
  }

  // More efficient approach - target specific tags with optimized regex
  // This is faster than a single broad regex that processes the entire string
  return html
    .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, " ")
    .replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, " ")
    .replace(/<[^>]+>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function stripAllHtml(html) {
  if (!html) {
    return "";
  }

  // First strip HTML tags using existing function
  let text = stripHTML(html);

  // Then decode HTML entities using a temporary DOM element
  if (typeof document !== "undefined") {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = text;
    text = tempDiv.textContent || tempDiv.innerText || "";
  } else {
    // Fallback for server-side or when DOM is not available
    // Handle common HTML entities manually
    text = text
      .replace(/&nbsp;/g, " ")
      .replace(/&amp;/g, "&")
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&quot;/g, '"')
      .replace(/&#039;/g, "'")
      .replace(/&#x27;/g, "'")
      .replace(/&#x2F;/g, "/")
      .replace(/&#(\d+);/g, (match, dec) => String.fromCharCode(dec))
      .replace(/&#x([0-9a-f]+);/gi, (match, hex) =>
        String.fromCharCode(parseInt(hex, 16))
      );
  }

  // Final cleanup of whitespace
  return text.replace(/\s+/g, " ").trim();
}

export function truncateText(text, length = 75) {
  return text.length > length ? text.substr(0, length - 1) + "..." : text;
}

export const isMobile = (() => {
  if (
    typeof navigator === "undefined" ||
    typeof navigator.userAgent !== "string"
  ) {
    return false;
  }
  return /Mobile/.test(navigator.userAgent);
})();

export const isMobileViewport = (breakpoint = 768) => {
  if (typeof window === "undefined") {
    return false;
  }
  return window.innerWidth <= breakpoint;
};

export const birthDateFormatter = (date) => {
  const useOnlyMonthYearForDOB = FeaturesService.useOnlyMonthYearForDOB();

  if (useOnlyMonthYearForDOB) {
    // Month/year only format - parses as UTC, uses locale-aware format
    return dateFormatService.formatDOBMonthYear(date);
  }

  // Date only (no time) - parses as UTC, uses locale-aware format
  return dateFormatService.formatDOB(date);
};

export const dashboardPeriodFilter = (api, filter) => {
  if (filter) {
    let newApi = api;
    let utcMoment = moment.utc;
    let fromDate = null,
      toDate = null;

    // If fromDate and toDate are directly provided (from DateRangePicker)
    if (filter.fromDate && filter.toDate) {
      // Convert YYYY-MM-DD format to DDMMYYYY format
      fromDate = moment(filter.fromDate).format("DDMMYYYY");
      toDate = moment(filter.toDate).format("DDMMYYYY");
    } else if (filter.duration) {
      // Handle legacy duration-based filtering
      let duration = filter.duration;
      switch (duration) {
        case "today":
          fromDate = utcMoment().format("DDMMYYYY");
          toDate = utcMoment().format("DDMMYYYY");
          break;
        case "7days":
          fromDate = utcMoment().subtract(7, "days").format("DDMMYYYY");
          toDate = utcMoment().format("DDMMYYYY");
          break;
        case "10days":
          fromDate = utcMoment().subtract(10, "days").format("DDMMYYYY");
          toDate = utcMoment().format("DDMMYYYY");
          break;
        case "1month":
          fromDate = utcMoment().subtract(1, "months").format("DDMMYYYY");
          toDate = utcMoment().format("DDMMYYYY");
          break;
        case "2month":
          fromDate = utcMoment().subtract(2, "months").format("DDMMYYYY");
          toDate = utcMoment().format("DDMMYYYY");
          break;
        case "3month":
          fromDate = utcMoment().subtract(3, "months").format("DDMMYYYY");
          toDate = utcMoment().format("DDMMYYYY");
          break;
        case "6month":
          fromDate = utcMoment().subtract(6, "months").format("DDMMYYYY");
          toDate = utcMoment().format("DDMMYYYY");
          break;
        case "12month":
          fromDate = utcMoment().subtract(1, "years").format("DDMMYYYY");
          toDate = utcMoment().format("DDMMYYYY");
          break;
        default:
          fromDate = utcMoment().subtract(7, "days").format("DDMMYYYY");
          toDate = utcMoment().format("DDMMYYYY");
          break;
      }
    }

    if (fromDate) {
      newApi += `&fromDate=${fromDate}`;
    }
    if (toDate) {
      newApi += `&toDate=${toDate}`;
    }
    return newApi;
  }
  return api;
};

export function formatDateTimeWithTimezone(date) {
  const format = "DD/MM/YY HH:mm";
  const momentDate = moment(date);
  const formattedDate = momentDate.format(format);
  const timezoneOffset = momentDate.format("Z"); // Gets the timezone offset (e.g., "+02:00")
  return `${formattedDate} (GMT${timezoneOffset})`;
}

export function extractFirstNWordsFromHTML(htmlString, wordCount = 100) {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = htmlString;
  // Remove non-visible/media elements before extracting text
  tempDiv.querySelectorAll("script, style, noscript, audio, video").forEach(el => el.remove());
  const textContent = tempDiv.textContent || tempDiv.innerText || "";
  const words = textContent.trim().split(/\s+/);
  // Check if there's more content beyond the limit
  const hasMore = words.length > wordCount;
  // Slice and format output
  const result = words.slice(0, wordCount).join(" ");
  return hasMore ? `${result}...` : result;
}

export function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}
/**
 * Creates a safe setState wrapper using a ref-based approach that is safer than _isMounted
 *
 * @param {React.Component} component - The component instance
 * @returns {Function} - A function that safely calls setState only if component is mounted
 */
export function createSafeSetState(component) {
  if (!component || typeof component.setState !== "function") {
    console.error(
      "createSafeSetState requires a valid React component instance"
    );
    return () => { };
  }

  // Create a local variable to track if callbacks should run
  let isMounted = true;

  // For class components, hook into componentWillUnmount to update our local flag
  const originalWillUnmount = component.componentWillUnmount;
  component.componentWillUnmount = function () {
    isMounted = false;
    if (typeof originalWillUnmount === "function") {
      originalWillUnmount.call(component);
    }
  };

  return function safeSetState(stateUpdate, callback) {
    if (isMounted) {
      component.setState(stateUpdate, callback);
    }
  };
}

/**
 * Safely executes a promise and updates component state only if the component is still mounted
 * Using an AbortController for proper cancellation support
 *
 * @param {Promise} promise - The promise to execute
 * @param {React.Component} component - The component instance
 * @param {Function} setStateCallback - Function that takes the result and returns state update object
 * @param {Function} [errorCallback] - Optional function to handle errors
 * @returns {Object} - Controller object with abort() method to cancel the operation
 */
export function safePromise(
  promise,
  component,
  setStateCallback,
  errorCallback
) {
  // Create an abortion controller and signal
  const controller = new AbortController();
  const { signal } = controller;

  // For class components, hook into componentWillUnmount
  const originalWillUnmount = component.componentWillUnmount;
  component.componentWillUnmount = function () {
    controller.abort();
    if (typeof originalWillUnmount === "function") {
      originalWillUnmount.call(component);
    }
  };

  // Run the promise with the signal
  Promise.resolve(promise)
    .then((result) => {
      if (!signal.aborted && typeof setStateCallback === "function") {
        component.setState(setStateCallback(result));
      }
      return result;
    })
    .catch((error) => {
      // Don't process errors if aborted
      if (signal.aborted) return;

      if (typeof errorCallback === "function") {
        errorCallback(error);
      } else {
        console.error("Unhandled error in safePromise:", error);
      }
      return error;
    });

  // Return the controller so component can abort if needed
  return controller;
}

/**
 * Utility to estimate the size of a JavaScript object
 * Uses a more efficient approach for large objects by using
 * a sampling strategy for deeply nested objects
 *
 * @param {Object} object - The object to measure
 * @param {Object} options - Configuration options
 * @param {number} options.maxDepth - Maximum depth to traverse
 * @param {boolean} options.sampling - Whether to use sampling for large arrays
 * @returns {Object} - Size in bytes, KB, and MB
 */
export function getObjectSize(
  object,
  options = { maxDepth: 20, sampling: true }
) {
  try {
    // For null or primitives, return calculated size directly
    if (object === null || typeof object !== "object") {
      const str = String(object);
      return {
        bytes: str.length * 2, // Unicode chars are ~2 bytes
        kb: Math.round((str.length * 2) / 1024),
        mb: ((str.length * 2) / (1024 * 1024)).toFixed(2),
      };
    }

    // Use a more sophisticated size estimation algorithm
    let bytes = 0;

    function sizeOf(value, depth = 0) {
      // Prevent infinite recursion
      if (depth > options.maxDepth) {
        return 8; // Reference size
      }

      if (value === null) return 4;

      const type = typeof value;

      // Handle primitive types
      if (type === "boolean") return 4;
      if (type === "number") return 8;
      if (type === "string") return value.length * 2;

      // Handle arrays with sampling for large arrays
      if (Array.isArray(value)) {
        const length = value.length;

        // For large arrays, use sampling
        if (length > 1000 && options.sampling) {
          // Sample approximately 10% of items, with a minimum of 100
          const sampleSize = Math.max(100, Math.floor(length * 0.1));
          const sampleInterval = Math.floor(length / sampleSize);

          let sampleTotal = 0;
          for (let i = 0; i < length; i += sampleInterval) {
            sampleTotal += sizeOf(value[i], depth + 1);
          }

          // Extrapolate the total size
          return (sampleTotal / sampleSize) * length;
        }

        // For smaller arrays, process everything
        let total = 0;
        for (let i = 0; i < length; i++) {
          total += sizeOf(value[i], depth + 1);
        }
        return total;
      }

      // Handle objects
      if (type === "object") {
        let total = 0;
        for (const key in value) {
          if (Object.prototype.hasOwnProperty.call(value, key)) {
            // Add size of key
            total += key.length * 2;
            // Add size of value
            total += sizeOf(value[key], depth + 1);
          }
        }
        return total;
      }

      // Default case
      return 8;
    }

    bytes = sizeOf(object);

    return {
      bytes,
      kb: Math.round(bytes / 1024),
      mb: (bytes / (1024 * 1024)).toFixed(2),
    };
  } catch (error) {
    console.error("Error calculating object size:", error);

    // Fallback to JSON stringify for simple estimate
    try {
      const jsonString = JSON.stringify(object);
      const bytes = jsonString.length;
      return {
        bytes,
        kb: Math.round(bytes / 1024),
        mb: (bytes / (1024 * 1024)).toFixed(2),
      };
    } catch (e) {
      return { bytes: 0, kb: 0, mb: 0 };
    }
  }
}

/**
 * Developer utility to clear persisted Redux state
 * This can be called from the browser console to fix storage quota issues
 */
export function clearReduxPersistence() {
  try {
    // Clear localStorage
    if (window.localStorage) {
      window.localStorage.removeItem("persist:root");
      console.log("Cleared Redux persistence from localStorage");
    }

    // Clear sessionStorage
    if (window.sessionStorage) {
      window.sessionStorage.removeItem("persist:root");
      console.log("Cleared Redux persistence from sessionStorage");
    }

    console.log("Refresh the page to see the changes take effect");
    return true;
  } catch (error) {
    console.error("Error clearing Redux persistence:", error);
    return false;
  }
}

/**
 * Checks if the sidebar is currently minimized
 */
export function isSidebarMinimized() {
  if (typeof document !== "undefined") {
    return document.body.classList.contains("sidebar-minimized");
  }
  return false;
}

/**
 * Collapses the sidebar programmatically by simulating a click on the SidebarMinimizer button
 * This ensures that the component state stays in sync with the CSS classes
 * Falls back to direct CSS class manipulation if the button is not found
 *
 * @returns {boolean} - Returns true if the sidebar was collapsed (state changed), false if already minimized
 */
export function collapseSidebar() {
  if (typeof document === "undefined") {
    return false;
  }

  // Check if already minimized
  if (isSidebarMinimized()) {
    return false;
  }

  // Try to find and click the sidebar minimizer button to keep state in sync
  const minimizerButton = document.querySelector(
    ".sidebar .sidebar-minimizer-btn"
  );

  if (minimizerButton) {
    // Simulate click to properly update component state
    minimizerButton.click();
    return true;
  } else {
    // Fallback: directly add classes if button not found
    document.body.classList.add("sidebar-minimized");
    document.body.classList.add("brand-minimized");
    return true;
  }
}

/**
 * Expands the sidebar programmatically by simulating a click on the SidebarMinimizer button
 * This ensures that the component state stays in sync with the CSS classes
 * Falls back to direct CSS class manipulation if the button is not found
 * Uses requestAnimationFrame to ensure the click happens at the right time in the browser's rendering cycle
 *
 * @returns {boolean} - Returns true if the sidebar was expanded (state changed), false if already expanded
 */
export function expandSidebar() {
  if (typeof document === "undefined") {
    return false;
  }

  // Check if already expanded
  if (!isSidebarMinimized()) {
    return false;
  }

  // Try to find and click the sidebar minimizer button to keep state in sync
  const minimizerButton = document.querySelector(
    ".sidebar .sidebar-minimizer-btn"
  );

  if (minimizerButton) {
    // Use requestAnimationFrame to ensure DOM is ready and the click happens at the right time
    requestAnimationFrame(() => {
      minimizerButton.click();
    });
    return true;
  } else {
    // Fallback: directly remove classes if button not found
    document.body.classList.remove("sidebar-minimized");
    document.body.classList.remove("brand-minimized");
    return true;
  }
}

/**
 * Toggles the sidebar between collapsed and expanded states
 * This ensures that the component state stays in sync with the CSS classes
 */
export function toggleSidebar() {
  if (isSidebarMinimized()) {
    expandSidebar();
  } else {
    collapseSidebar();
  }
}

/**
 *
 * Extracts and returns the string representation of a given attribute object.
 * @param {*} attribute
 * @returns the attribute value
 */

export const getAttributeValueAsString = (attribute) => {
  if (!attribute || !attribute.value) return "";

  let value = attribute.value;

  // Handle nested valueObservation structure (common for observation-type attributes)
  if (value.valueObservation && value.valueObservation.value) {
    value = value.valueObservation.value;
  }

  // Handle different value types
  if (value.valueHumanName) {
    // Handle human names (patient names, etc.)
    return value.valueHumanName.text || "";
  } else if (value.valueCode) {
    // Handle coded concepts (gender, status codes, etc.)
    return value.valueCode.display || value.valueCode.code || "";
  } else if (value.valueDate != null) {
    // Use formatDOB for DOB attributes to avoid timezone shifting
    if (dateFormatService.isDOBAttribute(attribute)) {
      return dateFormatService.formatDOB(value.valueDate);
    }
    return dateFormatService.formatDate(value.valueDate);
  } else if (value.valueDateTime) {
    return dateFormatService.formatDateTime(value.valueDateTime);
  } else if (value.valueQuantity !== undefined) {
    return value.valueQuantity;
  } else if (value.valueInteger !== undefined) {
    return value.valueInteger;
  } else if (value.valueDouble !== undefined) {
    return value.valueDouble;
  } else if (value.valueBoolean !== undefined) {
    return value.valueBoolean ? "Yes" : "No";
  } else if (value.valueCodeableConcept) {
    return value.valueCodeableConcept.text || "";
  } else if (value.valueAddress) {
    // Handle address fields (MPS_ADDRESS)
    return value.valueAddress.text || "";
  } else if (value.valueString) {
    return value.valueString;
  } else if (value.valueAsString) {
    // Fallback to valueAsString if present
    return value.valueAsString;
  } else if (value.valueContactPoints && value.valueContactPoints.length > 0) {
    return value.valueContactPoints[0].value || "";
  }

  return "";
};
